import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import validationform from '../../../validation/validationform';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VoicemailService } from './service/voicemail.service';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { NotifierService } from 'angular-notifier';
import { NgSelectConfig } from '@ng-select/ng-select';
import { LoginService } from '../../../components/login/service/login.service';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-voice-mailupload',
  templateUrl: './voice-mailupload.component.html',
  styleUrl: './voice-mailupload.component.scss'
})
export class VoiceMailuploadComponent {

  
  fileData: any = [];
  fileDataName: any = [];
  showComponent = false;
  storeFormDataPayload: any = [];
  storeAudioApiService: any[] = [];
  storePdfApiService: any[] = [];
  storeTextApiService: any[] = [];
  selectFile = '';
  hideMic = false;
  topicsFileData: any = [];
  topicsValue: any = [];
  uploadForm!: FormGroup;
  showCard = false;
  topicsData: any = [];
  sampleArray: any = [];
  editTopic: any;
  countCall!: number;
  countMetric!: number;
  getIndex!: number;
  uuid = uuidv4();
  storeFormData: any;
  selectedCar!: number;
  disableInput = true;
  formObject = {};
  userDetails!: any;
  inputBoolean = true;
  spinner = false;
  disableUpBtn = false;
  languageAudio: any = [];
  fileIndex!: number;
  clientcodeId:any;
  private readonly notifier: NotifierService;
  @Input() agentname: any;
  splitPattern = new RegExp('[,;]');
  isDirty = false;
  openModal = false;
  getFileEvent: any;
  myOptions:any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    trigger: 'hover',
    shadow: true,
  };
  @ViewChild('fileUpload') fileUploadEle!: ElementRef;
  @ViewChild('fileUpload2') fileUploadEle2!: ElementRef;
  @ViewChild('fileUpload3') fileUploadEle3!: ElementRef;
  @ViewChild('fileUpload5') fileUploadEle5!: ElementRef;
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective!: DaterangepickerDirective;
  getDateData: any;
  startDate: any;
  convertJson: any;
  fileUploadCountBoolean: boolean = true;
  constructor(
    private uploadService: VoicemailService,
    private fb: FormBuilder,
    private ngSelect: NgSelectConfig,
    private service:LoginService,
    private notifierService: NotifierService,
    private router: Router
  ) {
    this.ngSelect.notFoundText = 'Custom not found';
    this.notifier = notifierService;
  }
  canDeactivate(): boolean {
    return !this.isDirty;
  }

  ngOnChanges() {}

  ngOnInit(): void {
    let user = localStorage.getItem("user");
          if(user){
            var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
            this.userDetails = JSON.parse(data);
            this.clientcodeId = this.userDetails['cli_code']['$oid'];
          }  
    
    this.uploadForm = this.fb.group({
      displayName: [null,[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      customerName: [null,[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      agentName: [null, Validators.required],
      bounds: [null],
      topicName: [null, Validators.required],
      keywords: [null],
      alertKeywords: [null],
      sensitiveKeywords: [null],
      hideKeywords: [null],
      deleteKeywords: [null],
      negativeKeywords: [null],
      positiveKeywords: [null],
      auditComments: [null,Validators.pattern(/^[A-Za-z0-9]+(?:\s[A-Za-z0-9]+)*$/)],
      language: [null],
      emailfrom: [''],
      emailto: [''],
      cc: [''],
      bcc: [''],
      emailsubject: ['',Validators.pattern(/^[a-zA-Z0–9]+(?:\s[A-Za-z0-9]+)*$/)],
      emaildate: [''],
      isrepeat: [false],
      // uploadfile: [null],
      // metricForm: this.fb.array([]),
      // callCategoryForm: this.fb.array([]),
    });
    this.languageAudio = [
      { name: 'English', code: 'en-US' },
      { name: 'Spanish', code: 'es-ES' },
      { name: 'Tamil', code: 'ta-IN' },
      { name: 'Hindi', code: 'hi-IN' },
      { name: 'Marathi', code: 'mr-IN' },
      { name: 'Bengali', code: 'bn-IN' },
      { name: 'Gujarati', code: 'gu-IN' },
      { name: 'Malayalam', code: 'ml-IN' },
      { name: 'Kannada', code: 'kn-IN' },
      { name: 'Telugu', code: 'te-IN' },
    ];
    this.uploadForm.controls['language'].setValue(this.languageAudio[0].code);
  }
  // get callCategoryForm() {
  //   return this.uploadForm.controls['callCategoryForm'] as FormArray;
  // }

  // get metricForm() {
  //   return this.uploadForm.controls['metricForm'] as FormArray;
  // }

  // addcallCategoryForm() {
  //   const lessonForm = this.fb.group({
  //     callCategory: [null, Validators.required],
  //     callKeyword: [null, Validators.required],
  //     callColor: [null, Validators.required],
  //   });
  //   this.callCategoryForm.push(lessonForm);
  //   this.showCard = true;
  // }

  // deletecallCategoryForm(index: number) {
  //   this.callCategoryForm.removeAt(index);
  // }

  // addMetricForm() {
  //   const lessonForm = this.fb.group({
  //     metricCategory: [null, Validators.required],
  //     metricKeyword: [null, Validators.required],
  //     metricScore: [null, Validators.required],
  //   });
  //   this.metricForm.push(lessonForm);
  //   this.showCard = true;
  // }

  // deleteMetricForm(index: number) {
  //   this.metricForm.removeAt(index);
  // }

  onFileChange(event: any,Filetypes:any) {
    this.getFileEvent = event;
    
   // this.showComponent = this.validateFileSelect(event,Filetypes);
    if(!this.validateFileSelect(event,Filetypes)){
      this.notifier.notify(
        'default',
        "Sorry we can't process the File Type. Only accepted files "+Filetypes.join(", ")
      );
      if (this.selectFile === 'audio') {
        this.fileUploadEle.nativeElement.value = null;
      }
      if (this.selectFile === 'pdf') {
        this.fileUploadEle2.nativeElement.value = null;
      }
      if (this.selectFile === 'email') {
        this.fileUploadEle3.nativeElement.value = null;
      }
      return;
    }else{
      this.callTopics();
    }
    let format = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/;
    if (this.getFileEvent.target.files.length > 0) {
      this.isDirty = true;
      for (let i = 0; this.getFileEvent.target.files.length > i; i++) {
        const file = this.getFileEvent.target.files[i];
        if (format.test(file.name)) {
          this.notifier.notify(
            'default',
            "Sorry we can't process the File name with special character."
          );
        } else {
          this.fileData.push(file);
          this.fileDataName.push(file.name);
        }
      }
    }
    this.containsDuplicate(this.fileDataName);

    if (this.selectFile === 'audio') {
      this.fileUploadEle.nativeElement.value = null;
    }
    if (this.selectFile === 'pdf') {
      this.fileUploadEle2.nativeElement.value = null;
    }
    if (this.selectFile === 'email') {
      this.fileUploadEle3.nativeElement.value = null;
      this.uploadForm.controls['emailfrom'].setValidators([Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]);
    } else {
      this.uploadForm.controls['emailfrom'].clearValidators();
      this.uploadForm.controls['emailfrom'].updateValueAndValidity();
    }
  }
  containsDuplicate(array: any) {
    if (array.length !== new Set(array).size) {
      this.notifier.notify('default', 'Duplicate files are not allowed');
      this.fileData = this.removeDuplicates2(this.fileData, 'name');
      this.fileDataName = this.removeDuplicates1(this.fileDataName);
    }
  }
  callTopics() {
    this.showComponent = true;
    if (this.showComponent) {
      this.isDirty = true;
      this.uploadForm.controls['language'].setValue('en-US');
      this.uploadForm.controls['agentName'].setValue(this.userDetails?.name);
      this.uploadService.getFile().subscribe((res: any) => {
        this.topicsFileData = [];
        this.topicsFileData = res.topics;
      });
    }
  }

  removeDuplicates1(data: any) {
    return data.filter(
      (value: any, index: any) => data.indexOf(value) === index
    );
  }
  removeDuplicates2(myArray: any, Prop: any) {
    return myArray.filter((obj: any, pos: any, arr: any) => {
      return arr.map((mapObj: any) => mapObj[Prop]).indexOf(obj[Prop]) === pos;
    });
  }

  get f() {
    return this.fileData.value;
  }

  filesFormat(value: any) {
    this.selectFile = value;
    if (this.selectFile === 'pdf') {
      this.uploadForm.controls['customerName'].setValue('John');
    }
    if (this.selectFile === 'email') {
      this.uploadForm.controls['customerName'].setValue('John');
    }
    if (this.selectFile === 'audio') {
      this.uploadForm.controls['customerName'].setValue('');
    }
  }

  deleteSelectFile(index: number) {
    this.fileData.splice(index, 1);
    if (this.fileData.length === 0) {
      this.fileData = [];
      this.getFileEvent = '';
    }
  }
  justShowIndex(index: number) {
    this.fileIndex = index;
  }

  chooseTopic() {
    const id = this.uploadForm.controls['topicName'].value;
    if (this.uploadForm.controls['topicName'].valid) {
      this.uploadService.getTopic(id).subscribe((sub:any) => {
        this.editTopic = sub;
        this.formObject = {
          topicName: id,
          keywords: this.editTopic.keywords
            ? this.editTopic.keywords?.split(',')
            : null,
          alertKeywords: this.editTopic.alert_words
            ? this.editTopic.alert_words?.split(',')
            : null,
          sensitiveKeywords: this.editTopic.sensitive_words
            ? this.editTopic.sensitive_words?.split(',')
            : null,
          hideKeywords: this.editTopic.hide_words
            ? this.editTopic.hide_words?.split(',')
            : null,
          deleteKeywords: this.editTopic.delete_words
            ? this.editTopic.delete_words?.split(',')
            : null,
        };
        this.uploadForm.patchValue(this.formObject);
        this.disableInput = false;
      });
    } else if (this.uploadForm.controls['topicName'].invalid) {
      Object.keys(this.formObject).forEach((key) => {
        this.uploadForm.controls[key].reset();
      });
      this.disableInput = true;
    }
  }

  onSubmit() {
    this.inputBoolean = true;
    if (this.fileData.length) {
      if (
        this.uploadForm.valid &&
        this.fileData.length > 0 &&
        this.fileData.length
      ) {
        this.spinner = true;
        this.disableUpBtn = true;
        this.storeFormData = this.uploadForm.value;
        const formInput = {
          displayfilename: this.storeFormData.displayName,
          clientcode:
            this.selectFile === 'audio' ? window.localStorage['loginuser'] : '',
          callername: this.storeFormData.customerName,
          agentname: this.uploadForm.controls['agentName'].value,
          topic: this.storeFormData.topicName,
          language: this.storeFormData.language,
          tag: '',
          ownkeywords: this.storeFormData.keywords
            ? this.storeFormData.keywords?.toString()
            : '',
          alertkeywords: this.storeFormData.alertKeywords
            ? this.storeFormData.alertKeywords?.toString()
            : '',
          hidekeywords: this.storeFormData.hideKeywords
            ? this.storeFormData.hideKeywords?.toString()
            : '',
          deletewords: this.storeFormData.deleteKeywords
            ? this.storeFormData.deleteKeywords?.toString()
            : '',
          sensitivewords: this.storeFormData.sensitiveKeywords
            ? this.storeFormData.sensitiveKeywords?.toString()
            : '',
          conversation: this.storeFormData.auditComments
            ? this.storeFormData.auditComments.toString()
            : '',
          smallfile: 'N',
          fileid: this.uuid,
          inbound: this.editTopic.call_type === 'inbound' ? 'true' : 'false',
          audio_call_type_status:'voice'
        };
        const formInputEmail = {
          displayfilename: this.storeFormData.displayName,
          clientcode:
            this.selectFile === 'audio' ? window.localStorage['loginuser'] : '',
          callername: this.storeFormData.customerName,
          agentname: this.uploadForm.controls['agentName'].value,
          topic: this.storeFormData.topicName,
          language: this.storeFormData.language,
          tag: '',
          ownkeywords: this.storeFormData.keywords
            ? this.storeFormData.keywords?.toString()
            : '',
          alertkeywords: this.storeFormData.alertKeywords
            ? this.storeFormData.alertKeywords?.toString()
            : '',
          hidekeywords: this.storeFormData.hideKeywords
            ? this.storeFormData.hideKeywords?.toString()
            : '',
          deletewords: this.storeFormData.deleteKeywords
            ? this.storeFormData.deleteKeywords?.toString()
            : '',
          sensitivewords: this.storeFormData.sensitiveKeywords
            ? this.storeFormData.sensitiveKeywords?.toString()
            : '',
          conversation: this.storeFormData.auditComments
            ? this.storeFormData.auditComments.toString()
            : '',
          smallfile: 'N',
          fileid: this.uuid,
          inbound: this.editTopic.call_type === 'inbound' ? 'true' : 'false',
          emailfrom: this.storeFormData.emailfrom,
          emailto: this.storeFormData.emailto
            ? this.storeFormData.emailto?.toString()
            : '',
          cc: this.storeFormData.cc ? this.storeFormData.cc?.toString() : '',
          bcc: this.storeFormData.bcc ? this.storeFormData.bcc?.toString() : '',
          emailsubject: this.storeFormData.emailsubject
            ? this.storeFormData.emailsubject
            : '',
          emaildate: this.startDate ? this.startDate : '',
          isrepeat: this.storeFormData.isrepeat ? 'Y' : 'N'
        };

        if (this.selectFile === 'email') {
          this.convertJson = JSON.stringify(formInputEmail);
        } else {
          this.convertJson = JSON.stringify(formInput);
        }
        for (let i = 0; this.fileData.length > i; i++) {
          const formDataAudio = new FormData();
          const formDataPdf = new FormData();
          const formDataText = new FormData();
          if (this.selectFile === 'audio') {
            formDataAudio.append('file', this.fileData[i]);
            formDataAudio.append('payload', this.convertJson);
            if (this.fileUploadCountBoolean) {
              this.storeAudioApiService.push(
                this.uploadService.uploadFile(formDataAudio)
              );
            }
          }
          if (this.selectFile === 'pdf') {
            if (this.fileData[i].type === 'application/pdf') {
              formDataPdf.append('file', this.fileData[i]);
              formDataPdf.append('payload', this.convertJson);
              if (this.fileUploadCountBoolean) {
                this.storePdfApiService.push(
                  this.uploadService.uploadPdf(formDataPdf)
                );
              }
            }
            if (
              this.fileData[i].type === 'text/plain' ||
              this.fileData[i].type ===
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            ) {
              formDataText.append('file', this.fileData[i]);
              formDataText.append('payload', this.convertJson);
              if (this.fileUploadCountBoolean) {
                this.storeTextApiService.push(
                  this.uploadService.uploadText(formDataText)
                );
              }
            }
          }
          if (this.selectFile === 'email') {
            formDataAudio.append('file', this.fileData[i]);
            formDataAudio.append('payload', this.convertJson);
            if (this.fileUploadCountBoolean) {
              this.storeAudioApiService.push(
                this.uploadService.uploadEmail(formDataAudio)
              );
            }
          }
        }

        if (this.selectFile === 'audio') {
          forkJoin(this.storeAudioApiService).subscribe({
            next: (response:any) => {
              this.spinner = false;
              this.disableUpBtn = false;
              this.isDirty = false;
              this.uploadForm.reset();
              this.convertJson = '';
              this.router.navigate(['/main/audioRecords']);
              this.fileUploadCountBoolean = true;
              this.notifier.notify('default', 'Successfully Uploaded !');
            },
            error: (error:HttpErrorResponse) => {
              console.log(error);
              this.spinner = false;
              this.disableUpBtn = false;
              this.fileUploadCountBoolean = false;
              this.notifier.notify('default', error.error?.message);
            },
          });
        }
        if (this.selectFile === 'pdf') {
          if (this.storePdfApiService) {
            forkJoin(this.storePdfApiService).subscribe({
              next: (response:any) => {
                this.spinner = false;
                this.disableUpBtn = false;
                this.isDirty = false;
                this.uploadForm.reset();
                this.selectFile = '';
                this.convertJson = '';
                this.router.navigate(['/main/textRecords']);
                this.fileUploadCountBoolean = true;
                this.notifier.notify(
                  'default',
                  'PDF files Successfully Uploaded !'
                );
              },
              error: (error:HttpErrorResponse) => {
                console.log(error);
                this.spinner = false;
                this.disableUpBtn = false;
                this.fileUploadCountBoolean = false;
                this.notifier.notify('default', error.error?.message);
              },
            });
          }
          if (this.storeTextApiService) {
            forkJoin(this.storeTextApiService).subscribe({
              next: (response) => {
                this.spinner = false;
                this.disableUpBtn = false;
                this.isDirty = false;
                this.uploadForm.reset();
                this.selectFile = '';
                this.convertJson = '';
                this.router.navigate(['/main/textRecords']);
                this.fileUploadCountBoolean = true;
                this.notifier.notify(
                  'default',
                  'Text files Successfully Uploaded !'
                );
              },
              error: (err) => {
                console.log(err);
                this.spinner = false;
                this.disableUpBtn = false;
                this.fileUploadCountBoolean = false;
                this.notifier.notify('default', err.error?.error);
              },
            });
          }
        }
        if (this.selectFile === 'email') {
          forkJoin(this.storeAudioApiService).subscribe({
            next: (response:any) => {
              this.spinner = false;
              this.disableUpBtn = false;
              this.isDirty = false;
              this.uploadForm.reset();
              this.selectFile = '';
              this.convertJson = '';
              this.router.navigate(['/main/textRecords']);
              this.fileUploadCountBoolean = true;
              this.notifier.notify('default', 'Successfully Uploaded !');
            },
            error: (error:HttpErrorResponse) => {
              console.log(error);
              this.spinner = false;
              this.disableUpBtn = false;
              this.fileUploadCountBoolean = false;
              this.notifier.notify('default', error.error?.message);
            },
          });
        }
      } else {
        this.notifier.notify('default', 'Please fill required fields !');
        validationform.ValidateAllFormFields(this.uploadForm);
        this.spinner = false;
      }
    } else {
      this.notifier.notify('default', 'Please choose a file');
    }
  }

  reDirectMainPage() {
    this.showComponent = false;
    this.fileData = [];
    this.isDirty = false;
    this.uploadForm.reset();
    this.getFileEvent = null;
    this.disableInput = true;
    this.spinner = false;
    this.disableUpBtn = false;
    this.uploadForm.controls['customerName'].setValue('');
    this.uploadForm.controls['emaildate'].setValue('');
    this.fileUploadCountBoolean = true;
    this.storeAudioApiService = [];
    this.storePdfApiService = [];
    this.storeTextApiService = [];
    if (this.selectFile === 'audio') {
      this.fileUploadEle.nativeElement.value = null;
    }
    if (this.selectFile === 'pdf') {
      this.fileUploadEle2.nativeElement.value = null;
    }
    if (this.selectFile === 'email') {
      this.fileUploadEle3.nativeElement.value = null;
    }
  }

  getDateSearchData(value: any) {
    this.getDateData = value;
    this.startDate = new DatePipe('en-US').transform(
      this.getDateData?.startDate?.$d || '',
      'MM/dd/yyyy'
    );
  }

  chooseUploadFilellm(event:any){
    const files = event.target.files[0];
    const formData = new FormData();
    formData.append('clientid',this.userDetails['userid']);
    formData.append('file', files,files.name);
    // this.uploadService.uploadLLMPdf(formData).subscribe((res:any)=>{
    //     //this.alert.showAlertMessage(res);
    //     this.notifier.notify(
    //       'success',
    //       res['message']
    //     );
    // });
  }

  chooseUploadSurveyFeedback(changeEvent:any,Filetypes:any){
    /*  var files = changeEvent.target.files;
                if (files.length) {
                    let r = new FileReader();
                    r.onload = function(e:any) {
                        let contents = e.target.result;
                        
                        var record = contents.split(/\r\n|\n/);
                        var headers = record[0].split(',');
                        var lines = [];
                        let json:any = {};
                    
                        for (var i = 0; i < record.length; i++) {
                            var data = record[i].split(',');
                            if (data.length == headers.length) {
                                var tarr = [];
                                for (var j = 0; j < headers.length; j++) {
                                    tarr.push(data[j]);
                                }
                                lines.push(tarr);
                            }
                        }
                        
                        for (let k = 0; k < lines.length; ++k){
                          json[k] = lines[k];
                        }
                        console.log(json.length);
                    };
                    
                    r.readAsText(files[0]);
                }
      */
    
    const files = changeEvent.target.files[0];
    let fileExtension = files.name.substring(files.name.lastIndexOf('.')+1, files.name.length);
    if (!Filetypes.includes(fileExtension)) {
      this.notifier.notify(
        'default',
        "Sorry we can't process the File."
      );
      this.fileUploadEle5.nativeElement.value = null;
      return;
    } 
    const formData = new FormData();
    formData.append('file', files,files.name);
    // this.notifier.notify('default', 'Successfully Uploaded !');
    // setTimeout(()=>{
    //   this.router.navigate(['surveyFeedback']);
    // },2000);
 
  
   
     this.uploadService.UploadSurveyFeedback(formData).subscribe({
      next:(res:any)=>{
         this.notifier.notify('default', 'Successfully Uploaded !');
          setTimeout(()=>{
             this.router.navigate(['/main/surveyFeedback']);
          },2000);
    }, error:(error:HttpErrorResponse)=>{
      console.log("error",error);
      this.spinner = false;
     }});
  }

  change_to_json(csv_data:any) {
    var record = csv_data.split(/\r\n|\n/);
    var headers = record[0].split(',');
    var lines = [];
    var json = {};

    for (var i = 0; i < record.length; i++) {
        var data = record[i].split(',');
        if (data.length == headers.length) {
            var tarr = [];
            for (var j = 0; j < headers.length; j++) {
                tarr.push(data[j]);
            }
            lines.push(tarr);
        }
    }
    
    // for (var k = 0; k < lines.length; ++k){
    //   json[k] = lines[k];
    // }
    return json;
 }

 validateFileSelect(event:any,Filetypes:any):any{
    let getFileEvent = event;
  if (getFileEvent.target.files.length > 0) {
    this.isDirty = true;
    for (let i = 0; this.getFileEvent.target.files.length > i; i++) {
      const file = this.getFileEvent.target.files[i];
      
      let fileExtension = file.name.substring(file.name.lastIndexOf('.')+1, file.name.length) || file.name;
      if (!Filetypes.includes(fileExtension)) {
        return false;
      }else{
        return true;
      }
    }
  }
 }

 onItemAdded(event:any,controlName:string){
  var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if (!filter.test(event.value)) {
            this.notifier.notify('error','Please provide a valid email address');
            let tag_value =  this.uploadForm.get(controlName)?.value;
            tag_value.splice(tag_value.length-1,1);
        }
  
 }
 onKeywordsAdded(event:any,controlName:string){
    var filter = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;

        if (!filter.test(event.value)) {
            this.notifier.notify('error','Please provide a valid keywords');
            let tag_value =  this.uploadForm.get(controlName)?.value;
            tag_value.splice(tag_value.length-1,1);
        }
 }
}
 

